import { DataObject } from "../core/data/DataObject";
/**
 * BalanceParams.ts
 */
export class BalanceParams {
    constructor(forceRefresh) {
        this.forceRefresh = forceRefresh;
    }
    liquify() {
        return new DataObject(this);
    }
}
//# sourceMappingURL=BalanceParams.js.map